import React from 'react';
import { Link } from 'react-router-dom';
import { Container ,Button} from 'react-bootstrap';
import './notfound.css'
const Notfound=(props)=>{
	console.log(props);
	return(
		<Container  className="mt-5 page-not-found">
				<p style={{textAlign:"center"}}>
					 
		             <Button  href="/" className>Go Home </Button> 
		  		</p>
		 </Container>	 	
	)

}

export default Notfound